import { render, staticRenderFns } from "./TestimonialTabReadOnly.vue?vue&type=template&id=2319d69f&"
import script from "./TestimonialTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./TestimonialTabReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialTabReadOnly.vue?vue&type=style&index=0&id=2319d69f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports